/**
 * Inline Scripts Orchestrator
 * Initializes all extracted inline scripts in the correct order
 *
 * This module replaces the inline <script> tags that were previously in dist/index.html
 * All scripts are now properly modularized and bundled via Vite
 */

import { initializeSupabase } from './supabase-init.js';
import { initServiceSelection } from './service-selection.js';
import { initUniversalSearch } from './universal-search.js';
import { initConditionsLogging } from './conditions-logging.js';
import { initWizardPayment } from './wizard-payment.js';
import { initEnhancedChargeFlow } from './enhanced-charge-flow.js';

/**
 * Initialize all inline scripts
 * Called automatically when this module is imported
 */
export function initializeInlineScripts() {
  console.log('🚀 Initializing inline scripts...');

  // 1. Initialize Supabase first (required by all other scripts)
  initializeSupabase();

  // 2. Initialize service selection (button handlers)
  initServiceSelection();

  // 3. Initialize universal search (customer/boat search)
  initUniversalSearch();

  // 4. Initialize conditions logging (boat history tracking)
  initConditionsLogging();

  // 5. Initialize wizard payment (payment processing)
  initWizardPayment();

  // 6. Initialize enhanced charge flow (saved payment methods)
  initEnhancedChargeFlow();

  console.log('✅ All inline scripts initialized successfully');
}

// Auto-initialize when module is imported
initializeInlineScripts();
